import { render, staticRenderFns } from "./questionBankExamPaperList.vue?vue&type=template&id=54c1cf04&scoped=true"
import script from "./questionBankExamPaperList.vue?vue&type=script&lang=js"
export * from "./questionBankExamPaperList.vue?vue&type=script&lang=js"
import style0 from "./questionBankExamPaperList.vue?vue&type=style&index=0&id=54c1cf04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1cf04",
  null
  
)

export default component.exports